interface LoadingDotsProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  label?: string;
}

const sizeMap = {
  small: 'w-1.5 h-1.5',
  medium: 'w-2 h-2',
  large: 'w-3 h-3',
};

export function LoadingDots({ size = 'medium', className = '', label = 'Loading' }: LoadingDotsProps) {
  const dotSize = sizeMap[size];

  return (
    <div role="status" aria-label={label} className={`flex items-center gap-1.5 ${className}`}>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          aria-hidden="true"
          className={`${dotSize} rounded-full bg-[var(--accent)]`}
          style={{
            animation: 'loading-dot 1.4s ease-in-out infinite',
            animationDelay: `${i * 0.16}s`,
          }}
        />
      ))}
    </div>
  );
}
